export default "__VITE_ASSET__D_1Va5RA__"